import { PanelRow } from '../IntakeBilling/PanelRow';
import { PanelSelectRow } from '../IntakeBilling/PanelSelectRow';
import { PanelTextRow } from '../IntakeBilling/PanelTextRow';
import { InsuranceDetails, insuranceRows } from './insuranceDetails';
import { InsuranceCard } from './useInsuranceCard';

interface InsuranceCardRowsProps {
  card: InsuranceCard;
  details: InsuranceDetails;
  labels: { insurer: string; memberId: string; group: string };
  /** Member ID and group are absent, not "Not provided", until there is an insurer (the panel). */
  hideIdsWithoutInsurer?: boolean;
}

/**
 * Insurer, member ID and group: the three facts a benefit check needs, edited in place by the roles
 * the bot lets edit and read by everyone else.
 */
export function InsuranceCardRows({ card, details, labels, hideIdsWithoutInsurer }: InsuranceCardRowsProps) {
  const { editable, insurerEditable, insurerOptions, saveEdit } = card;
  const rows = insuranceRows(details);
  const showIds = !hideIdsWithoutInsurer || !!details.insurer || details.insurerNotListed || !!details.memberId;

  return (
    <>
      {insurerEditable ? (
        <PanelSelectRow
          label={labels.insurer}
          value={details.insurer?.name}
          options={insurerOptions.map((option) => option.name)}
          placeholder={rows.insurer.text}
          searchable
          onChange={async (name) => {
            const option = insurerOptions.find((candidate) => candidate.name === name);
            if (!option) return;
            await saveEdit({ insurer: { reference: option.reference } });
          }}
        />
      ) : (
        <PanelRow label={labels.insurer} value={rows.insurer.text} muted={rows.insurer.muted} />
      )}
      {showIds &&
        (editable ? (
          <PanelTextRow
            label={labels.memberId}
            value={details.memberId}
            display={rows.memberId.text}
            muted={rows.memberId.muted}
            onSave={(memberId) => saveEdit({ memberId: memberId || null })}
            testId="insurance-member-id-input"
          />
        ) : (
          <PanelRow label={labels.memberId} value={rows.memberId.text} muted={rows.memberId.muted} />
        ))}
      {showIds &&
        (editable ? (
          <PanelTextRow
            label={labels.group}
            value={details.groupNumber}
            display={rows.group.text}
            muted={rows.group.muted}
            onSave={(groupNumber) => saveEdit({ groupNumber: groupNumber || null })}
            testId="insurance-group-input"
          />
        ) : (
          <PanelRow label={labels.group} value={rows.group.text} muted={rows.group.muted} />
        ))}
    </>
  );
}
